var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsulinNoMealIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25112_69635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25112_69635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 32.25L28 22.25V14C28 12.8667 28.2416 11.7083 28.725 10.525C29.2083 9.34167 29.8333 8.26667 30.6 7.3C31.3666 6.33333 32.2166 5.54167 33.15 4.925C34.0833 4.30833 35 4 35.9 4C36.5 4 37 4.23333 37.4 4.7C37.8 5.16667 38 5.71667 38 6.35V32.25ZM42.4 45.15C42 45.55 41.525 45.75 40.975 45.75C40.425 45.75 39.95 45.55 39.55 45.15L36.4 42.05H38C38 42.6167 37.8083 43.0917 37.425 43.475C37.0416 43.8583 36.5666 44.05 36 44.05C35.4333 44.05 34.9583 43.8583 34.575 43.475C34.1916 43.0917 34 42.6167 34 42.05V39.65L2.79995 8.45C2.39995 8.05 2.19995 7.56667 2.19995 7C2.19995 6.43333 2.39995 5.95 2.79995 5.55C3.19995 5.15 3.67495 4.95 4.22495 4.95C4.77495 4.95 5.24995 5.15 5.64995 5.55L42.4 42.35C42.8 42.75 43 43.2167 43 43.75C43 44.2833 42.8 44.75 42.4 45.15ZM24 18.25L20 14.25V6C20 5.43333 20.1916 4.95833 20.575 4.575C20.9583 4.19167 21.4333 4 22 4C22.5666 4 23.0416 4.19167 23.425 4.575C23.8083 4.95833 24 5.43333 24 6V18.25ZM18 12.25L14 8.25V6C14 5.43333 14.1916 4.95833 14.575 4.575C14.9583 4.19167 15.4333 4 16 4C16.5666 4 17.0416 4.19167 17.425 4.575C17.8083 4.95833 18 5.43333 18 6V12.25ZM12 6.25L9.74995 4C10.3833 4 10.9166 4.21667 11.35 4.65C11.7833 5.08333 12 5.61667 12 6.25ZM16 44C15.4333 44 14.9583 43.8083 14.575 43.425C14.1916 43.0417 14 42.5667 14 42V25.7C12.3 25.2333 10.875 24.3 9.72495 22.9C8.57495 21.5 7.99995 19.8667 7.99995 18V7.95L12 11.95V18H14V13.95L18 17.95V18H18.05L22.55 22.5C22.0166 23.2667 21.3583 23.925 20.575 24.475C19.7916 25.025 18.9333 25.4333 18 25.7V42C18 42.5667 17.8083 43.0417 17.425 43.425C17.0416 43.8083 16.5666 44 16 44Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulinNoMealIcon);
export default __webpack_public_path__ + "static/media/insulin-no-meal-icon.71512eb17ab5d8c8062e3c38616ba819.svg";
export { ForwardRef as ReactComponent };